import 'antd/lib/modal/style';
import 'antd/lib/icon/style';

import '../VtxModal.less';